import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { ItemType, MappingItemIdIndexType } from '../types';
import GantGridArrow from './gantGridArrow';

interface IGantGridListArrow {
    item: ItemType;
}

const GantGridListArrow: React.FC<IGantGridListArrow> = ({ item }) => {
    const itemsList = useSelector<RootState, ItemType[]>((state) => state.gantItems.itemsList);
    const mappingItemIdIndex = useSelector<RootState, MappingItemIdIndexType>((state) => state.gant.mappingItemIdIndex);

    const getListArrowSS = () => {
        if (item.bondParentSS.length) {
            return item.bondParentSS.map((bondId) => {
                const childItem = itemsList[mappingItemIdIndex[bondId]];

                return (
                    childItem &&
                    !childItem.hideForCollapse && (
                        <GantGridArrow
                            key={`${item.id}-${childItem.id}`}
                            startItem={item}
                            endItem={childItem}
                            draggingStart={'bondLeft'}
                            draggingEnd={'bondLeft'}
                            isAbsolute
                        />
                    )
                );
            });
        }
    };

    const getListArrowSE = () => {
        if (item.bondParentSE.length) {
            return item.bondParentSE.map((bondId) => {
                const childItem = itemsList[mappingItemIdIndex[bondId]];

                return (
                    childItem &&
                    !childItem?.hideForCollapse && (
                        <GantGridArrow
                            key={`${item.id}-${childItem.id}`}
                            startItem={item}
                            endItem={childItem}
                            draggingStart={'bondLeft'}
                            draggingEnd={'bondRight'}
                            isAbsolute
                        />
                    )
                );
            });
        }
    };

    const getListArrowES = () => {
        if (item.bondParentES.length) {
            return item.bondParentES.map((bondId) => {
                const childItem = itemsList[mappingItemIdIndex[bondId]];

                return (
                    childItem &&
                    !childItem.hideForCollapse && (
                        <GantGridArrow
                            key={`${item.id}-${childItem.id}`}
                            startItem={item}
                            endItem={childItem}
                            draggingStart={'bondRight'}
                            draggingEnd={'bondLeft'}
                            isAbsolute
                        />
                    )
                );
            });
        }
    };

    const getListArrowEE = () => {
        if (item.bondParentEE.length) {
            return item.bondParentEE.map((bondId) => {
                const childItem = itemsList[mappingItemIdIndex[bondId]];

                return (
                    childItem &&
                    !childItem.hideForCollapse && (
                        <GantGridArrow
                            key={`${item.id}-${childItem.id}`}
                            startItem={item}
                            endItem={childItem}
                            draggingStart={'bondRight'}
                            draggingEnd={'bondRight'}
                            isAbsolute
                        />
                    )
                );
            });
        }
    };

    return (
        <>
            {getListArrowSS()}
            {getListArrowSE()}
            {getListArrowES()}
            {getListArrowEE()}
        </>
    );
};

export default React.memo(GantGridListArrow);
